import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-router-switch-btn',
  imports: [RouterLink],
  templateUrl: './router-switch-btn.component.html',
})
export class RouterSwitchBtnComponent {
  @Input({ required: true }) urlLink: string = '';
  @Input({ required: true }) title: string = '';
  @Input() btnStyling: string = 'btn btn-outline-dark';
}
